import { Button, Popconfirm, Space, message } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import useGetSearchColumnProps from "../../../../common/hooks/SearchData";
import { IPermission, ISetState } from "../../../../common/types/commonTypes";
import { useDeleteAirlineMutation } from "../Endpoints/airlineEndpoints";
import { AirlineDataType } from "../types/AirlinesTypes";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../auth/states/userSlice";

type Props = {
  setEditInfo: ISetState<AirlineDataType | null>;
  showModal: () => void;
  permission?: IPermission;
  pagination: {
    current: number;
    pageSize: number;
  };
};

export const airlinesColumns = ({
  pagination,
  setEditInfo,
  showModal,
  permission,
}: Props): ColumnsType<AirlineDataType> => {
  const [columnIndex, setColumnIndex] = useState<number | null>(null);

  const searchColumnProps = useGetSearchColumnProps<AirlineDataType>();
  const user = useSelector(selectUser);
  const handleClick = (record: AirlineDataType) => {
    setEditInfo(record);
    showModal();
  };

  const [deleteAirline, { isError, isSuccess, isLoading }] =
    useDeleteAirlineMutation();
  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
      message.success("Airline Deleted Successfully");
    } else if (isError) {
      setColumnIndex(null);
      message.error("Something went wrong");
    }
  }, [isSuccess, isError]);

  const handleDelete = async (values: AirlineDataType, index: number) => {
    setColumnIndex(index);
    await deleteAirline({ ...values, deleted_by: user?.user_id });
  };

  return [
    {
      title: "SL.",
      dataIndex: "key",
      key: "serial",
      render: (_, data, index) => (
        <>
          {((pagination.current || 1) - 1) * (pagination.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },
    {
      title: "Airline Name",
      dataIndex: "airline_name",
      key: "airline_name",
      align: "left",
      width: 400,
      ...searchColumnProps("airline_name"),
    },
    {
      title: "Airline Code",
      dataIndex: "airline_code",
      key: "airline_code",
    },
    {
      title: "Actions",
      key: "operation",
      render: (_, record, index) => (
        <Space size="small">
          {permission?.["update:any"] && record.agency_id && (
            <Button
              size="small"
              type="primary"
              onClick={() => handleClick(record)}
            >
              Edit
            </Button>
          )}
          {permission?.["delete:any"] && record.agency_id && (
            <Button
              danger
              size="small"
              type="primary"
              loading={columnIndex === index && true}
            >
              <Popconfirm
                title="Sure to delete?"
                onConfirm={() => handleDelete(record, index)}
              >
                Delete
              </Popconfirm>
            </Button>
          )}
        </Space>
      ),
    },
  ];
};
